// extracted by extract-css-chunks-webpack-plugin
module.exports = {"table":"table_QodK7","table__inner":"table__inner_aCFdW","ui_mask":"ui_mask_EpzMw"};